export default __webpack_public_path__ + "static/media/Strangler's Tunic of the Firebringer.0dc78544.jpg";